import React, { useEffect } from "react";
// import { useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../About/Navbar";

// import { Trans } from "react-i18next";

function PressPage() {
    const { t } = useTranslation();

    const press_2021 = [
        {
            key: 0,
            label: "In the News",
            date: "17 Dec 2021",
            preText:
                "Predictions for 2022 by Puneet Rai, yslearn’s Head of Sales. You can read here: ",
            text: "B2B News for Friday, December 17, 2021: More Cloud on the Horizon, Learning & Development Predictions, Talent Drives the Bus",
            image: "https://www.b2bnn.com/wp-content/uploads/2020/12/356962CA-C0AC-4CDB-A77E-249EDC1DADC2.jpeg",
            link: "https://www.b2bnn.com/2021/01/the-opportunity-to-co-invent-an-invitation-to-learning-and-development-professionals/",
            source: "B2B News Network",
        },
        {
            key: 1,
            label: "In the News",
            date: "09 May 2021",
            preText: "Commentary by yslearn co-founder Vishal Shah",
            text: "India’s Terrible Pandemic Grief is Your Long-Term Loss",
            image: "https://images.thestar.com/5vJzH4rgQABFZqmIaWB3L2iMQ7s=/744x446/smart/http://media.zuza.com/1/4/14ae795a-f9c1-4af1-9866-92e9e6a16918/RSSDailies_71cd51b4_8e1e_4641_82a6_c6da762aaf5f_Image1_Super_Portrait.jpg",
            link: "https://www.niagarathisweek.com/opinion-story/10390213-india-s-terrible-pandemic-grief-is-your-long-term-loss/",
            source: "Niagara this Week",
        },
        {
            key: 2,
            label: "In the News",
            date: "26 Jan 2021",
            preText: "Commentary by yslearn co-founder Arvind Betala",
            text: "Getting Online Education Right. Ideas for a Better Second Semester",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/artImage2.webp`,
            link: "https://www.thespec.com/opinion/contributors/2021/01/07/getting-online-education-right-ideas-for-a-better-second-semester.html",
            source: "The Hamilton Spectator",
        },
        {
            key: 3,
            label: "In the News",
            date: "13 Jun 2020",
            preText: "Thought leadership by yslearn co-founder Arvind Betala",
            text: "The Opportunity to Co-Invent: An Invitation to Learning & Development Professionals",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/artImage3.webp`,
            link: "https://www.b2bnn.com/2021/01/the-opportunity-to-co-invent-an-invitation-to-learning-and-development-professionals/",
            source: "B2B News Network",
        },
        {
            key: 4,
            label: "Press Release",
            preText: "",
            date: "10 June 2021",
            text: "Renowned Conservationist Matthew Richardson to Teach Kids How to Protect Endangered Species with yslearn",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
            link: "https://www.newsfilecorp.com/release/87222/Renowned-Conservationist-Matthew-Richardson-to-Teach-Kids-to-Protect-Endangered-Species-with-smiklearn",
            source: "Newsfile",
        },
        {
            key: 5,
            label: "Press Release",
            date: "10 June 2021",
            preText: "",
            text: "yslearn Enters Partnership with Master Coach & Accumatch Founder Nagui Bihelek",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
            link: "https://www.newsfilecorp.com/release/87220/smiklearn-Enters-Partnership-with-Master-Coach-Accumatch-Founder-Nagui-Bihelek",
            source: "Newsfile",
        },
        {
            key: 6,
            label: "Press Release",
            date: "06 Apr 2021",
            preText: "",
            text: "yslearn Partners with AI Expert Brian Lenahan to Offer Business Leaders Crucial Learning Opportunity",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
            link: "https://www.newsfilecorp.com/release/79571/smiklearn-Partners-with-AI-Expert-Brian-Lenahan-to-Offer-Business-Leaders-Crucial-Learning-Opportunity",
            source: "Newsfile",
        },
        {
            key: 7,
            label: "Press Release",
            date: "26 Jan 2021",
            preText: "",
            text: "yslearn Seeks Strategic Partners to Co-Invent New LMS Landscape",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
            link: "https://www.newsfilecorp.com/release/72884/smiklearn-Seeks-Strategic-Partners-to-CoInvent-New-LMS-Landscape",
            source: "Newsfile",
        },
    ];
    const press_2022 = [
        {
            key: 0,
            label: "Press Release",
            date: "01 Feb 2022",
            preText: "",
            text: "yslearn & the Babb Group Announce Strategic Merger",
            image: `${process.env.REACT_APP_SMIK_API_BASEURL}/press/newsfile.svg`,
            link: "https://www.newsfilecorp.com/release/112383",
            source: "Newsfile",
        },
    ];

    return (
        <div className="InternalPage">
            <div className="mt-[150px]">
            <Navbar />
            </div>
            <section className="InternalHead press ">
                <div className="internal-text">
                    <h1 className="title center">{t("News & Press")}</h1>
                    <p className="center">
                        {t(
                            "yslearn’s activities reported in business and the community"
                        )}
                    </p>
                </div>
            </section>

            <section className="InternalBody">
                <div className="press-wrapper">
                    <div className="page-title">2022</div>
                    <div className="press-inner-wrapper">
                        {press_2022.map((item) => {
                            return (
                                <article className="press-item" key={item.key}>
                                    <div className="image-wrapper">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={item.link}
                                        >
                                            <img
                                                alt="article"
                                                src={item.image}
                                            />
                                        </a>
                                    </div>

                                    <div className="content-wrapper">
                                        <div className="date">
                                            {item.date}
                                            <span className="press-label">
                                                {item.label}
                                            </span>
                                        </div>

                                        <div className="article-title">
                                            <span>{item.preText}</span>
                                            <span>
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={item.link}
                                                >
                                                    {item.text}
                                                </a>
                                            </span>
                                        </div>

                                        <div className="source-link">
                                            In {item.source}
                                            {/* <i className="logo-B2BNewsNetwork" /> */}
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>

                    <div className="page-title">2021</div>
                    <div className="press-inner-wrapper">
                        {press_2021.map((item) => {
                            return (
                                <article className="press-item" key={item.key}>
                                    <div className="image-wrapper">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={item.link}
                                        >
                                            <img
                                                alt="article"
                                                src={item.image}
                                            />
                                        </a>
                                    </div>

                                    <div className="content-wrapper">
                                        <div className="date">
                                            {item.date}
                                            <span className="press-label">
                                                {item.label}
                                            </span>
                                        </div>

                                        <div className="article-title">
                                            <span>{item.preText}</span>
                                            <span>
                                                <a
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    href={item.link}
                                                >
                                                    {item.text}
                                                </a>
                                            </span>
                                        </div>

                                        <div className="source-link">
                                            In {item.source}
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default PressPage;
